import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CustomPagination from "../util/CustomPagination";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import HospitalDepartmentRegisterModal from "../hospital/HospitalDepartmentRegisterModal";
import Skeleton from "react-loading-skeleton";
import UsersSearch from "../dashboard/calender/UsersSearch";
import Swal from "sweetalert2";


const ManagersModal = ({show, onHide, user}) => {

    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [showManagersHospitalRegister, setShowManagersHospitalRegister] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [hospitalsManagers, setHospitalsManagers] = useState([]);
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        user_id: "",
    });


    const fetchHospitalManagers = async (page = 1) => {
        try {
            setLoading(true);
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}managers/list`,
                {
                    per_page: 5,
                    page: page,
                    user_id: user?.id || undefined
                },
                true);
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setHospitalsManagers(data);
            setPagination(pagInfo);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }


    };


    useEffect(() => {
        if (show && user) {
            fetchHospitalManagers(1);
        }
    }, [show]);

    const handleShowModalRegister = () => {
        setShowManagersHospitalRegister(true);
    };

    const handleHospitalRegisterModalClose = (save =false) => {
        setShowManagersHospitalRegister(false);
        if(save) {
            fetchHospitalManagers(pagination.current);  // Atualiza a lista após cadastro
        }
    };

    const handlePageChange = (page) => {
        fetchHospitalManagers(page);
    };

    const handleFilterChange = (selectedOption) => {
        setFilters({
            ...filters,
            department_id: selectedOption ? selectedOption.value : ""
        });
    };

    const handleDelete = async (hospitalsManager) => {

        try {
            const response = await ApiService.send('delete', `${process.env.REACT_APP_URL_API}managers/delete`,
                {
                    id: hospitalsManager?.id,
                },
                true
            );

            Swal.fire({
                title: 'Sucesso!',
                text: 'Usuário removido do hospital com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            }).then(() => {
                fetchHospitalManagers(1);
            });

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Listar Regras</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                                <div className="row filtro-body mb-3">
                                    <div className="col-9">
                                        <UsersSearch 
                                            initialUser={user}
                                            onUserSelect={(user) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                user_id: user?.value || "",
                                            }))
                                        }/>
                                    </div>
                                    <div className="col-3 form-group mb-3 mt-2">
                                        <button type="button" className="btn btn-success me-2  mt-4"
                                                onClick={() => fetchHospitalManagers(1)}>
                                            <i className="fa fa-search"></i> Buscar
                                        </button>
                                    </div>
                                </div>


                    {loading ? (
                        <Skeleton count={5} height={30} style={{marginBottom: "10px"}}/>
                    ) : (
                        <div className="hospital-list" style={{maxHeight: '400px', overflowY: 'auto'}}>
                            {hospitalsManagers.length > 0 ? (
                                hospitalsManagers.map((hospitalsManager) => (
                                    <div key={hospitalsManager.id}
                                         className="hospital-item d-flex flex-column align-items-start mb-3"
                                         style={{
                                             backgroundColor: '#fff',
                                             borderRadius: '8px',
                                             padding: '15px 20px',
                                             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                             borderLeft: '5px solid #20c997'
                                         }}>
                                        <div className="d-flex align-items-center  w-100">
                                            <div className="row col-12  align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <div className="col-12 row">
                                                        <div className="col-4">
                                                            <h5 className="mb-0 mt-1"
                                                                style={{fontSize: '14px', color: '#333'}}>
                                                                <i className="fa fa-user text-primary"
                                                                   style={{
                                                                       fontSize: '20px',
                                                                       color: '#20c997'
                                                                   }}></i>&nbsp;&nbsp;{hospitalsManager.user?.name || 'Usuário não especificado'}
                                                            </h5>
                                                        </div>
                                                        <div className="col-3">
                                                            <h5 className="mb-0 mt-1"
                                                                style={{fontSize: '14px', color: '#333'}}>
                                                                <i className="fa fa-building text-primary"
                                                                   style={{
                                                                       fontSize: '20px',
                                                                       color: '#20c997'
                                                                   }}></i>&nbsp;&nbsp;{hospitalsManager.hospital?.name || 'Local não especificado'}
                                                            </h5>
                                                        </div>
                                                        <div className="col-3">
                                                            <h5 className="mb-0 mt-1"
                                                                style={{fontSize: '14px', color: '#333'}}>
                                                                <i className="fa fa-ambulance text-primary"
                                                                   style={{
                                                                       fontSize: '20px',
                                                                       color: '#20c997'
                                                                   }}></i>&nbsp;&nbsp;{hospitalsManager.department?.name || 'Departamento não especificado'}
                                                            </h5>
                                                        </div>
                                                        <div className="col-2">
                                                            <button type="button" className="btn btn-danger"
                                                                    onClick={() => handleDelete(hospitalsManager)}>
                                                                <i className="fa fa-trash"
                                                                   aria-hidden="true"></i> Excluir
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="alert alert-info">Faça sua pesquisa para encontrar regras.</div>
                            )}
                            <CustomPagination pagination={pagination} onChange={handlePageChange}/>
                        </div>

                    )}
                </Modal.Body>
            </Modal>


        </>
    );
};

export default ManagersModal;
